
const toggle = () => {
    document.querySelectorAll('.js-detail-toggle').forEach(head => {
        if(!document.querySelector('.js-detail-toggle')) return false;

        head.addEventListener('click', () => {
            const item = head.closest('.js-item');
            const content = item.querySelector('.js-item__content');
            const cursor = head.querySelector('.c-cards-faq__arrow');

            content.classList.toggle('is-open');

            if (cursor) {
                const current = cursor.dataset.direction;
                cursor.dataset.direction = current === 'bottom' ? 'top' : 'bottom';
            }
        });
    });
}

const faq = () => {
    toggle();
}
export default faq
